export default {"src":"/_next/static/media/france.20598265.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};